<script setup lang="ts">
import every24HoursPreviewType from "@/types/responses/every24HoursPreview";

type rowItemType = {
  id: string,
  dataName: string,
  dataKey: string,
  class: string,
  isConvertToJson: boolean,
}

const props = defineProps<{
  deliveryPlan: every24HoursPreviewType
  index: number
  rowItems: rowItemType[]
  chartDetails: {
    deliveryPlanDate: string,
    displayStartTime: string,
    drivingDistance: string,
    drivingTime: string
  }
}>();

function displayData(dataKey: string) {
  return props.chartDetails ? props.chartDetails[dataKey] : props.deliveryPlan[dataKey];
}
</script>
<template>
  <tbody>
    <tr>
      <template v-for="item in props.rowItems" :key="item">
        <td
          :class="item.class"
        >
          {{ displayData(item.dataKey) }}
        </td>
      </template>
    </tr>
  </tbody>
</template>
<style scoped>
table tbody tr:hover {
  background-color: white !important;
}
</style>
